import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoMgh: CultureInfo = {
  name: 'mgh',
  displayName: 'Makua',
  iso3LanguageCode: 'mgh',
  iso2LanguageCode: 'mgh',
  ietfLanguageTag: 'mgh',
  parent: null
};
